export const DEFAULT_PAGE_SIZE_OPTIONS = [50, 100, 200]
export const DEFAULT_INITIAL_PAGE_SIZE = 50
